/**
 * Validación y UI de receta médica en el carrito Farmex.
 * Extraído de main-cart-items.liquid para respetar límite de tamaño Shopify.
 */
(function (win) {
  'use strict';

  function fetchCart() {
    if (typeof win.getCart === 'function') return win.getCart();
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function normalizeCampaignKey(value) {
    return (value || '').toString().toLowerCase().replace(/\s+/g, '').trim();
  }

  function campaignRequiresRecetaAlways(campaign) {
    var key = normalizeCampaignKey(campaign);
    if (!key) return false;
    var recetaCampaignKeys = [
      'metlife', 'consorcio', 'sermecoop', 'supplementary_insurance',
      'seguroscomplementarios', 'seguroscomplementariosycajalosandes', 'segurocomplementario'
    ];
    return recetaCampaignKeys.indexOf(key) !== -1;
  }

  function campaignExemptFromReceta(campaign) {
    if (campaignRequiresRecetaAlways(campaign)) return false;
    var key = normalizeCampaignKey(campaign);
    if (!key) return false;
    var exemptKeys = [
      'fonasa', 'sura', 'afp', 'cajalosandes', 'chilesalud', 'delvallecargo',
      'recetasolidaria', 'solomujer', 'mujerartemisa', 'banmedica', 'vidatres',
      'patient_programs', 'programasdepacientes', 'programasdepacientesycajalosandes',
      'beneficiocomunalascondes', 'beneficiocomunanunoa', 'cajalosheroes'
    ];
    return exemptKeys.indexOf(key) !== -1;
  }

  function getDominantCampaignFromPage(cart) {
    try {
      var campania = localStorage.getItem('Campania');
      if (campania && campania !== 'null') return campania.toString().trim();
    } catch (e) { /* noop */ }
    if (typeof jQuery !== 'undefined') {
      var checked = (jQuery('input[name="inputBeneficios"]:checked').val() || '').toString().replace(/\s+/g, '').trim();
      if (checked) return checked;
    }
    try {
      var fromSession = sessionStorage.getItem('yapp_input_beneficios_value');
      if (fromSession) return fromSession.toString().replace(/\s+/g, '').trim();
    } catch (e) { /* noop */ }
    var att = (cart && cart.attributes) || {};
    var fromCart = (att.campaign || att.Campaign || '').toString().trim();
    if (fromCart) return fromCart;
    if (typeof jQuery !== 'undefined' && jQuery('input.campaign').length) {
      var fromInput = jQuery('input.campaign').val();
      if (fromInput) return fromInput.toString().trim();
    }
    return '';
  }

  function collectCampaignSources(cart) {
    var sources = [];
    var att = (cart && cart.attributes) || {};
    var fromCart = (att.campaign || att.Campaign || '').toString().trim();
    if (fromCart) sources.push(fromCart);
    if (typeof jQuery !== 'undefined') {
      if (jQuery('input.campaign').length) {
        var fromInput = jQuery('input.campaign').val();
        if (fromInput) sources.push(fromInput.toString().trim());
      }
      var fromCheckbox = (jQuery('input[name="inputBeneficios"]:checked').val() || '').toString().replace(/\s+/g, '').trim();
      if (fromCheckbox) sources.push(fromCheckbox);
    }
    try {
      var fromStorage = localStorage.getItem('Campania');
      if (fromStorage) sources.push(fromStorage.toString().trim());
      var fromSession = sessionStorage.getItem('yapp_input_beneficios_value');
      if (fromSession) sources.push(fromSession.toString().replace(/\s+/g, '').trim());
    } catch (e) { /* noop */ }
    return sources;
  }

  function getRecetaRequiringCampaignFromPage(cart) {
    var sources = collectCampaignSources(cart);
    for (var i = 0; i < sources.length; i++) {
      if (campaignRequiresRecetaAlways(sources[i])) return sources[i];
    }
    return '';
  }

  function getActiveCampaignFromPage(cart) {
    var recetaCampaign = getRecetaRequiringCampaignFromPage(cart);
    if (recetaCampaign) return recetaCampaign;
    var sources = collectCampaignSources(cart);
    return sources.length ? sources[0] : '';
  }

  function isSeguroComplementarioActivo() {
    try {
      var dominant = getDominantCampaignFromPage();
      if (campaignExemptFromReceta(dominant)) return false;
      if (campaignRequiresRecetaAlways(dominant)) return true;
      var sources = collectCampaignSources();
      for (var i = 0; i < sources.length; i++) {
        if (campaignRequiresRecetaAlways(sources[i])) return true;
      }
      if (localStorage.getItem('negotiatedPriceYapp') === 'true') {
        return campaignRequiresRecetaAlways(localStorage.getItem('Campania'));
      }
    } catch (e) { /* noop */ }
    return false;
  }

  async function clearRecetaCertificacionIfExempt(cart) {
    var dominant = getDominantCampaignFromPage(cart);
    if (!campaignExemptFromReceta(dominant)) return;
    var att = (cart && cart.attributes) || {};
    var needsCartUpdate = att.CertificarMetlife === 'true' || att.CertificarMetlife === true;
    localStorage.setItem('isCertificacion', 'false');
    if (!needsCartUpdate) return;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            campaign: dominant || att.campaign || '',
            CertificarMetlife: 'false',
            rut: att.rut || '',
            cupon: att.cupon || '',
            recetas: att.recetas || ''
          }
        })
      });
    } catch (e) {
      console.warn('No se pudo limpiar CertificarMetlife:', e);
    }
  }

  function showRecetaUIPanelsForConvenio(certCheck) {
    if (!certCheck || !certCheck.requires) return;
    localStorage.setItem('isCertificacion', 'true');
    if (certCheck.campaign && typeof jQuery !== 'undefined' && jQuery('input.campaign').length) {
      jQuery('input.campaign').val(certCheck.campaign);
    }
    if (campaignRequiresRecetaAlways(certCheck.campaign) &&
        normalizeCampaignKey(certCheck.campaign) !== 'supplementary_insurance' &&
        normalizeCampaignKey(certCheck.campaign) !== 'segurocomplementario') {
      var metlifeKey = normalizeCampaignKey(certCheck.campaign);
      if (metlifeKey === 'metlife' || metlifeKey === 'consorcio' || metlifeKey === 'sermecoop') {
        localStorage.setItem('ClienteMetlife', 'Si');
      }
    }
    var third = document.getElementById('third-step');
    if (third) {
      third.style.display = '';
      third.classList.remove('d-none');
    }
  }

  function getLocalStorageRecetaCampaign() {
    try {
      var lsCampania = localStorage.getItem('Campania');
      if (!lsCampania || lsCampania === 'null') return '';
      if (!campaignRequiresRecetaAlways(lsCampania)) return '';
      return lsCampania.toString().trim();
    } catch (e) {
      return '';
    }
  }

  function cartRequiresRecetaCertificacion(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return { requires: false, campaign: null };

    var lsRecetaCampaign = getLocalStorageRecetaCampaign();
    if (lsRecetaCampaign) {
      return { requires: true, campaign: lsRecetaCampaign };
    }

    var dominantCampaign = getDominantCampaignFromPage(cart);
    if (campaignExemptFromReceta(dominantCampaign)) {
      return { requires: false, campaign: dominantCampaign };
    }
    var recetaCampaign = getRecetaRequiringCampaignFromPage(cart);
    var campaignAttr = recetaCampaign || dominantCampaign || getActiveCampaignFromPage(cart);
    if (recetaCampaign) return { requires: true, campaign: recetaCampaign };
    if (isSeguroComplementarioActivo()) {
      return {
        requires: true,
        campaign: recetaCampaign || localStorage.getItem('Campania') || 'supplementary_insurance'
      };
    }
    var att = cart.attributes || {};
    var certAttr = att.CertificarMetlife || att.certificar_metlife;
    if ((certAttr === 'true' || certAttr === true) && campaignRequiresRecetaAlways(dominantCampaign || campaignAttr)) {
      return { requires: true, campaign: campaignAttr || null };
    }
    for (var i = 0; i < cart.items.length; i++) {
      var props = cart.items[i].properties || {};
      var isCert = props.isCertificacion;
      if ((isCert === 'true' || isCert === true) && !campaignExemptFromReceta(dominantCampaign)) {
        return { requires: true, campaign: campaignAttr || null };
      }
    }
    return { requires: false, campaign: campaignAttr || null };
  }

  function getBupaIdFromUrlOrSession() {
    try {
      var fromUrl = new URLSearchParams(win.location.search).get('bupa_id');
      if (fromUrl) {
        sessionStorage.setItem('bupa_id', fromUrl);
        return fromUrl;
      }
    } catch (e) { /* ignore */ }
    return sessionStorage.getItem('bupa_id') || null;
  }

  function hasBupaId() {
    return !!getBupaIdFromUrlOrSession();
  }

  function hideRecetaUIPanels(options) {
    options = options || {};
    if (!options.force && isSeguroComplementarioActivo()) return;
    var third = document.getElementById('third-step');
    if (third) {
      third.style.display = 'none';
      third.classList.add('d-none');
    }
    var detalle = document.getElementById('detalle-receta');
    if (detalle) detalle.style.display = 'none';
    var recetasSubidas = document.getElementById('recetasSubidas');
    if (recetasSubidas) recetasSubidas.style.display = 'none';
    if (typeof jQuery !== 'undefined') {
      jQuery('#modalRecetaRestringido').hide();
      jQuery('#modalMetlifeCertificacion').hide();
    }
    if (typeof win.clearRecetaRequeridaMensaje === 'function') win.clearRecetaRequeridaMensaje();
    if (options.clearStorage) {
      localStorage.setItem('isCertificacion', 'false');
      localStorage.setItem('RequiereReceta', 'false');
      ['validez_receta', 'Tus recetas:', 'recetas_con_nombre'].forEach(function (key) {
        localStorage.removeItem(key);
      });
      localStorage.setItem('Tus recetas:', '[]');
    }
    if (options.enableCheckout && typeof win.enableBtnCheckout === 'function') win.enableBtnCheckout();
  }

  function hideRecetaUIForBupa() {
    if (!hasBupaId()) return;
    hideRecetaUIPanels({ enableCheckout: true });
  }

  function getIsRecetaValid() {
    var ahora = new Date();
    var duracion_maxima = new Date(localStorage.getItem('validez_receta'));
    return ahora <= duracion_maxima;
  }

  async function ValidarReceta() {
    var $ = typeof jQuery !== 'undefined' ? jQuery : null;
    var cart = await fetchCart();
    var contadorRetenido = 0;
    var productosRetenidos = '';
    var itemsCart = {
      items: cart.items.map(function (item) {
        return { sku: item.sku, cantidad: item.quantity };
      })
    };

    try {
      var response = await fetch('https://services.farmex.cl/api/productos-receta', {
        method: 'POST',
        body: JSON.stringify(itemsCart),
        headers: { 'Content-Type': 'application/json' }
      });
      var responseData = await response.json();
      if (responseData.success && $) {
        var myJson = responseData.data;
        $('#liModal').remove();
        for (var i = 0; i < myJson.length; i++) {
          if (myJson[i].activo == '1') {
            productosRetenidos += "<li id='liModal'>" + myJson[i].nombreProducto + '</li>';
            contadorRetenido = 1;
          }
          var sku = myJson[i].sku;
          var spanDefault = document.getElementById(sku);
          var spanSidebar = document.getElementById(sku + 'SB');
          if (spanDefault) spanDefault.classList.remove('d-none');
          if (spanSidebar) spanSidebar.classList.remove('d-none');
        }
        if (contadorRetenido > 0) {
          var sinRecetas = (localStorage.getItem('Tus recetas:') == null || localStorage.getItem('Tus recetas:') == '[]') &&
            (!sessionStorage.getItem('folio_receta') || sessionStorage.getItem('folio_receta') == null) &&
            !hasBupaId();
          $('#idPasoRut h6').text('Paso 1');
          $('#idPasoImagen h6').text('Paso 3');
          $('#liModal').remove();
          $('#ulModal').append(productosRetenidos);
          $('#modalRecetaRestringido').show();
          $('#third-step').show();
          localStorage.setItem('isCertificacion', 'true');
          if (sinRecetas && typeof win.disableBtnCheckout === 'function') win.disableBtnCheckout();
          if (!sinRecetas) $('#recetasSubidas').show();
        } else if (!getLocalStorageRecetaCampaign()) {
          $('#recetasSubidas').hide();
        }
      } else if ($ && contadorRetenido === 0 && !isSeguroComplementarioActivo()) {
        $('#idPasoRut h6').text('Paso 1');
        $('#idPasoCart h6').text('Paso 2');
      }
    } catch (e) {
      console.warn('ValidarReceta API error:', e);
    }

    var certCheck;

    var cartFinal = await fetchCart();
    certCheck = cartRequiresRecetaCertificacion(cartFinal);
    var requiereReceta = contadorRetenido > 0 || certCheck.requires;
    if (
      contadorRetenido === 0 &&
      !getLocalStorageRecetaCampaign() &&
      campaignExemptFromReceta(getDominantCampaignFromPage(cartFinal))
    ) {
      requiereReceta = false;
      await clearRecetaCertificacionIfExempt(cartFinal);
    }
    if (requiereReceta) {
      if (certCheck.requires) showRecetaUIPanelsForConvenio(certCheck);
      if (contadorRetenido > 0 && $) $('#third-step').show();
      if ((localStorage.getItem('Tus recetas:') == null || localStorage.getItem('Tus recetas:') == '[]') &&
          (!sessionStorage.getItem('folio_receta') || sessionStorage.getItem('folio_receta') == null) &&
          !hasBupaId() && typeof win.disableBtnCheckout === 'function') {
        win.disableBtnCheckout();
      }
    } else {
      localStorage.setItem('isCertificacion', 'false');
      hideRecetaUIPanels({ enableCheckout: true, force: true });
    }
    if (!getIsRecetaValid()) localStorage.removeItem('validez_receta');
    if ($ && localStorage.getItem('Tus recetas:') != null && localStorage.getItem('Tus recetas:') != '[]') {
      $('#idPasoRut h6').text('Paso 1');
      $('#idPasoCart h6').text('Paso 2');
      if (contadorRetenido > 0 || certCheck.requires) {
        var detalleRecetaEl = document.getElementById('detalle-receta');
        if (detalleRecetaEl) detalleRecetaEl.style.display = 'block';
      }
    }
  }

  var recetaSyncTimer = null;
  var recetaSyncInFlight = false;

  async function syncRecetaUIAfterCartUpdate() {
    if (win.__farmexYappSyncingCart) return;
    if (recetaSyncInFlight) return;
    if (recetaSyncTimer) clearTimeout(recetaSyncTimer);
    recetaSyncTimer = setTimeout(async function () {
      recetaSyncTimer = null;
      if (win.__farmexYappSyncingCart) return;
      recetaSyncInFlight = true;
      try {
        if (hasBupaId()) {
          hideRecetaUIForBupa();
          return;
        }
        var cart;
        try {
          cart = await fetchCart();
        } catch (e) {
          return;
        }
        if (!cart.item_count) {
          hideRecetaUIPanels({ clearStorage: true, enableCheckout: true, force: true });
          return;
        }
        await ValidarReceta();
      } finally {
        recetaSyncInFlight = false;
      }
    }, 350);
  }

  win.normalizeCampaignKey = normalizeCampaignKey;
  win.campaignRequiresRecetaAlways = campaignRequiresRecetaAlways;
  win.campaignExemptFromReceta = campaignExemptFromReceta;
  win.getDominantCampaignFromPage = getDominantCampaignFromPage;
  win.collectCampaignSources = collectCampaignSources;
  win.getRecetaRequiringCampaignFromPage = getRecetaRequiringCampaignFromPage;
  win.getLocalStorageRecetaCampaign = getLocalStorageRecetaCampaign;
  win.getActiveCampaignFromPage = getActiveCampaignFromPage;
  win.isSeguroComplementarioActivo = isSeguroComplementarioActivo;
  win.clearRecetaCertificacionIfExempt = clearRecetaCertificacionIfExempt;
  win.showRecetaUIPanelsForConvenio = showRecetaUIPanelsForConvenio;
  win.cartRequiresRecetaCertificacion = cartRequiresRecetaCertificacion;
  win.getBupaIdFromUrlOrSession = getBupaIdFromUrlOrSession;
  win.hasBupaId = hasBupaId;
  win.hideRecetaUIPanels = hideRecetaUIPanels;
  win.hideRecetaUIForBupa = hideRecetaUIForBupa;
  win.getIsRecetaValid = getIsRecetaValid;
  win.ValidarReceta = ValidarReceta;
  win.syncRecetaUIAfterCartUpdate = syncRecetaUIAfterCartUpdate;

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        syncRecetaUIAfterCartUpdate();
      });
    }
  });
})(window);
